export default {
  Note: '通知',
  Sure: '确定',
  '': '',
  'Sign in': '请登录',
  'Phone Login': '手机登录',
  'Email Login': '邮箱登录',
  'I have read and agree to the': '我已阅读并同意',
  'Privacy Policy': '隐私协议',
  and: '和',
  'Terms of Use': '用户协议',
  Login: '登录',
  'Mobile number': '请输入您的手机号',
  'Please enter your full English name': '请输入您的完整英文名称',
  'Please enter a standardised English name': '请输入符合规范的英文名称',
  'Verification code': '请输入验证码',
  'Email address': '请输入邮箱',
  'Please enter a valid phone number!': '请输入正确的手机号！',
  'Please enter a valid email address!': '请输入正确的邮箱地址！',
  'Please enter your phone number!': '请输入手机号！',
  'Please enter your email address!': '请输入邮箱地址！',
  'Please enter the verification code!': '请输入验证码！',
  'Please accept the privacy policy and user agreement!': '请同意隐私协议及用户协议！',
  'Incorrect verification code, please check the code!': '验证码错误，请检查验证码！',
  'The verification code has expired, please retrieve a new one!': '验证码已过期，请重新获取验证码！',
  'The verification code has been used, please retrieve a new one!': '验证码已使用，请重新获取验证码！',
  'Login failed, please try again.': '登录失败，请重试',
  SEND: '获取验证码',
  ' ': '倒计时',
  'Currently in a meeting, please exit the current meeting before proceeding.': '正在会议中，请先退出当前会议后再进行操作',
  'Failed to initiate meeting': '发起会议失败',
  'Failed to enter the meeting': '进入会议失败',
  'Failed to enter the room.': '进入房间失败！',
  'This action causes the room to be exited, does it continue?': '该操作会导致退出房间，是否继续？',
  'This action causes the room to be disbanded, does it continue?': '该操作会导致解散房间，是否继续？',
  'Quick Conference': '的快速会议',
};
